import { render, staticRenderFns } from "./TermsPolitics.vue?vue&type=template&id=31c108d6&"
import script from "./TermsPolitics.vue?vue&type=script&lang=js&"
export * from "./TermsPolitics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports